import { render, staticRenderFns } from "./orderAcceptManager.vue?vue&type=template&id=0b3f547a&scoped=true"
import script from "./orderAcceptManager.vue?vue&type=script&lang=ts"
export * from "./orderAcceptManager.vue?vue&type=script&lang=ts"
import style0 from "./orderAcceptManager.vue?vue&type=style&index=0&id=0b3f547a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3f547a",
  null
  
)

export default component.exports